/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import DocumentAttachments from 'shared/ui/components/dev-tools/document-editor/DocumentAttachments.vue';
import DocumentInfo from 'shared/ui/components/dev-tools/document-editor/DocumentInfo.vue';
import DocumentRevisions from 'shared/ui/components/dev-tools/document-editor/DocumentRevisions.vue';
import JsonEditor from 'shared/ui/components/dev-tools/document-editor/JsonEditor.vue';
import LinkedDocuments from 'shared/ui/components/dev-tools/document-editor/LinkedDocuments.vue';

const __vue_script__ = {
    name: 'DocumentPanel',

    components: { DocumentAttachments, DocumentInfo, DocumentRevisions, JsonEditor, LinkedDocuments },

    props: {
        event: {
            type: Object,
            required: true
        },

        documentId: {
            type: String,
            default: 'metadata'
        },

        scrollTo: {
            type: String,
            default: null
        },

        mode: {
            type: String,
            default: 'text'
        },
    },

    data() {
        return {
            eid: this.event.id || this.event._id,
            currentTimestamp: 0,
            document: null,
            revisions: []
        };
    },

    computed: {
        showRevisions() {
            return this.revisions.length;
        }
    },

    created() {
        this.loadDocument(this.documentId);
    },

    methods: {
        /**
         * Retrieves a document from the database based on _id and _rev
         *
         * @param {string} id the id of the document to load
         * @param {string} [rev] the revision to load
         */
        async loadDocument(id, rev) {
            try {
                this.document = id ? await this.$services.appScripts.callAppScript(this.eid, 'dev-tools/get-doc', { id, rev }) : {};
                this.$emit('ready', this.document);
            } catch (error) {
                let serverError = get(error, 'response.data.error');
                if (typeof serverError === 'string') {
                    try { serverError = JSON.parse(serverError); } catch (e) { /* Probably not a JSON response */ }
                }

                if (serverError === 'deleted') {
                    this.$notify({
                        group: 'flashes',
                        title: this.$i18n.t('general.error_occurred').toString(),
                        text: this.$i18n.t('dev_tools.document_editor.messages.doc_deleted').toString(),
                        type: 'error',
                    });
                } else if (serverError.error === 'not_found') {
                    this.$notify({
                        group: 'flashes',
                        title: this.$i18n.t('general.error_occurred').toString(),
                        text: this.$i18n.t('dev_tools.document_editor.messages.doc_not_found').toString(),
                        type: 'error',
                    });

                } else {
                    console.error('[DocumentPanel] Could not load the document', error.message);
                    this.$notify({
                        group: 'flashes',
                        title: this.$i18n.t('general.error_occurred').toString(),
                        text: this.$i18n.t('dev_tools.document_editor.messages.could_not_load_doc', [error.message]).toString(),
                        type: 'error',
                    });
                }

                this.$emit('error', error);
            }
        },

        /**
         * Saves the document
         *
         * @param {object} doc the new document version
         */
        async saveDocument(doc) {
            try {
                const { id } = await this.$services.appScripts.callAppScript(this.eid, 'dev-tools/save', { doc });
                this.loadDocument(id);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('dev_tools.document_editor.document_saved').toString(),
                    type: 'success',
                    duration: 5000
                });

            } catch (error) {
                console.error('[DocumentPanel] Could not save the document', error.message);
                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('dev_tools.document_editor.messages.could_not_save_doc', [error.message]).toString(),
                    type: 'error',
                });
            }
        },

        cleanRevs() {
            delete this.document._revs_info;
            this.$emit('change', this.document);
        },

        parseSelection(selection) {
            if (selection.match(/^\d{9,10}$/)) {
                const number = Number.parseInt(selection);
                if (!Number.isNaN(number)) {
                    this.currentTimestamp = number;
                }
            } else {
                this.currentTimestamp = 0;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-panel"},[(_vm.document)?_c('json-editor',{attrs:{"mode":_vm.mode,"value":_vm.document,"event-id":_vm.eid,"scroll-to":_vm.scrollTo},on:{"changed":function (changed) { return _vm.$emit('changed', _vm.document, changed); },"change":function (current) { return _vm.$emit('change', current); },"reset":function($event){return _vm.loadDocument(_vm.document._id)},"select":_vm.parseSelection,"input":_vm.saveDocument}}):_vm._e(),(_vm.document)?_c('div',{staticClass:"meta"},[_c('document-info',{attrs:{"document":_vm.document,"timestamp":_vm.currentTimestamp,"event":_vm.event},on:{"select":function (id, p){ return _vm.$emit('select', id, p); }}}),_c('linked-documents',{attrs:{"document":_vm.document,"event-id":_vm.eid},on:{"select":function (id, p){ return _vm.$emit('select', id, p); }}}),_c('document-attachments',{attrs:{"document":_vm.document,"event-id":_vm.eid},on:{"save":_vm.saveDocument}}),_c('document-revisions',{attrs:{"document":_vm.document,"event-id":_vm.eid},on:{"select":_vm.loadDocument,"ready":_vm.cleanRevs,"compare":function (id, revA, revB) { return _vm.$emit('compare', id, revA, revB); }}})],1):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DocumentPanel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__